module.exports = __webpack_public_path__ + "Roboto-Regular.5136cbe62a63604402f2.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/dist/fonts/roboto/Roboto-Regular.woff2
// module id = 612
// module chunks = 2